import _ from 'lodash'

export const FETCH_BOTS = 'BOT/FETCH_BOTS'
export const FETCH_BOTS_SUCCESS = 'BOT/FETCH_BOTS_SUCCESS'
export const FETCH_FLOWS = 'BOT/FETCH_FLOWS'
export const FETCH_FLOWS_SUCCESS = 'BOT/FETCH_FLOWS_SUCCESS'

export const DELETE_BOT = 'DELETE_BOT'

export const fetchBots = () => ({
  type: FETCH_BOTS
})

export const fetchBotsSuccess = (payload) => ({
  type: FETCH_BOTS_SUCCESS,
  payload
})

export const fetchFlows = (botId) => ({
  type: FETCH_FLOWS,
  payload: {
    botId
  }
})

export const fetchFlowsSuccess = (botId, flows) => ({
  type: FETCH_FLOWS_SUCCESS,
  payload: {
    botId,
    flows
  }
})

export const deleteBot = (payload) => {
  return {
    type: DELETE_BOT,
    payload: _.pick(payload, ['botId'])
  }
}
